import { CLIENTS } from "../../data/content";

export default function Marquee() {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section data-testid="clients-marquee" className="py-14 border-y border-border overflow-hidden bg-card/30">
      <div className="relative">
        <div className="flex w-max marquee-track gap-16 px-8">
          {items.map((c, i) => (
            <span key={i} className="font-heading font-bold text-2xl md:text-3xl text-muted-foreground/50 whitespace-nowrap hover:text-primary transition-colors">{c}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
